module.exports = "/images/mu.svg?8f603f8f02914cc7c90518eec862f422";